import { Match } from "@shared/models/match";
import { AppLeague } from "@shared/models/league";
import { AppTeam } from "@shared/models/team";
import { Lineup } from "@shared/models/lineup/lineup";
import { Activity } from "@shared/models/activity";
import { Question } from "@shared/models/question";
import { Post } from "@shared/models/post";
import { MatchTeam } from "@shared/models/matchTeam";

export class MatchDetailViewMatch {
  currentTeamId: string = null;
  match: Match = null;
  league: AppLeague = null;
  homeTeam: AppTeam = null;
  awayTeam: AppTeam = null;
  homeLineup: Lineup = null;
  awayLineup: Lineup = null;
  minuteAndStatus: string = null;
  entries: (Activity | Question | Post)[] = [];
  matchPreviewText: string;
  public scores: { home: string, away: string } = { home: '-', away: '-' };

  get currentTeam(): MatchTeam {
    if (!this.currentTeamId && !this.match) {
      return null;
    }
    if (this.currentTeamId === this.match.teams.home.teamid) {
      return this.match.teams.home;
    } else if (this.currentTeamId === this.match.teams.away.teamid) {
      return this.match.teams.away;
    }
    return null;
  }

   public getLivetickerEntries(skip: number, limit: number): (Activity | Question | Post)[] {
    const nonQuestion = this.entries.filter(entry => !(entry instanceof Question));
    return nonQuestion.slice(skip, limit);
  }
}
